export default function getSeriesStreakItemId(index: number) {
  return `series-streak-session-${index}`
}
